
import { useIsMobile } from "@/hooks/use-mobile";
import DesktopSidebar from "./DesktopSidebar";

interface DesktopLayoutProps {
  children: React.ReactNode;
}

const DesktopLayout = ({ children }: DesktopLayoutProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <>{children}</>;
  }

  return (
    <div className="container px-8 py-4">
      <div className="flex gap-8">
        <DesktopSidebar />
        <main className="flex-1 max-w-5xl">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DesktopLayout;
